import { render, staticRenderFns } from "./Hotels.vue?vue&type=template&id=42a497a3"
import script from "./Hotels.vue?vue&type=script&lang=js"
export * from "./Hotels.vue?vue&type=script&lang=js"
import style0 from "./Hotels.vue?vue&type=style&index=0&id=42a497a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports